const REDIRECT_TO_PARAM = 'redirect-to'

export const toSameOriginPath = (raw: string, base: string): string | null => {
  try {
    const url = new URL(raw, base)

    return url.origin === new URL(base).origin &&
      ['http:', 'https:'].includes(url.protocol)
      ? `${url.pathname}${url.search}${url.hash}`
      : null
  } catch {
    return null
  }
}

/**
 * The browser keeps the hash of a backoffice deep link across the login redirect,
 * so it is copied into `redirect-to` before the portal router replaces it.
 */
export const moveCarriedHashIntoRedirect = ({
  hash,
  pathname,
  search,
}: Pick<Location, 'hash' | 'pathname' | 'search'>): string | null => {
  const params = new URLSearchParams(search)
  const redirectTo = params.get(REDIRECT_TO_PARAM)

  if (
    !redirectTo?.startsWith('/admin') ||
    redirectTo.includes('#') ||
    ['', '#', '#/'].includes(hash) ||
    hash.startsWith('#/login')
  ) {
    return null
  }

  params.set(REDIRECT_TO_PARAM, `${redirectTo}${hash}`)

  return `${pathname}?${params.toString()}${hash}`
}
